// deno-fmt-ignore-file
import { Array } from '../../types/array.mjs';
import { Immutable } from '../../types/_immutable.mjs';
export function FromArray(type) {
    const result = Immutable(Array(type));
    return result;
}
